





























































import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

import { MODULE_COLORS } from "@/utility/Constants";
import { CaosConfigurationTemplate } from "@/model/data/caosConfiguration/CaosConfigurationTemplate";
import { CaosConfigurationTemplateContentsEnum, caosConfigurationTemplateContentToString, i18nToEnum } from "@/model/data/enums/CaosConfigurationTemplateContentsEnum";

export default Vue.extend({
    props: { showDialog: Boolean, template: CaosConfigurationTemplate },
    data() {
        return {
            moment,
            MODULE_COLORS,
            CaosConfigurationTemplateContentsEnum,
        };
    },
    computed: {
        ...mapGetters(["longDateFormat"]),

        infos() {
            let infos = [
                { label: this.$t("caosTemplate.templateName"), value: this.template.name, icon: "font" },
                { label: this.$t("caosTemplate.sourceInstallation"), value: this.template.sourceInstallationName, icon: "hdd" },
                { label: this.$t("caosTemplate.caosVersion"), value: this.template.caosVersion, icon: "code-branch" },
                { label: this.$t("common.created_by"), value: this.template.createdBy, icon: "user" },
                { label: this.$t("common.created_on"), value: moment.utc(this.template.createdAt).local().format(this.longDateFormat(true, true, true, true)), icon: "clock" },
            ];
            if (this.template.description) infos.push({ label: this.$t("caosTemplate.templateDescription"), value: this.template.description, icon: "info" });
            return infos;
        },
        showTemplateInfoDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
            },
        },
    },
    methods: {
        caosConfigurationTemplateContentToString,
        i18nToEnum,
    },
});
